module.exports = flarum.core.compat['tags/forum/components/TagDiscussionModal'];